import React, { useEffect, useState, Fragment } from 'react';
import { withRouter, useHistory, useLocation } from 'react-router-dom';
import Wrapper from '../../../components/Wrapper/Wrapper';
import { tripTableHeight, tableHeightWithSparkline, tableHeightWithSparklineSingle } from "../../../../styleVariables";
import { connect } from "react-redux";
import MUIDataTable from "mui-datatables";
import TapLayout from "../../../components/PageLayout/TabLayOut";
import TopCard from "../../../components/TopCard/TopCard";
import { TRIP_FILTER_STATUS_MAPPING, TRIP_STATUS_LABELS, TRIP_ACTIONS_SUPPLIER } from '../../../../store/constants';
import { getSingleVendorLedgerData, getSingleVendorLedgerDataV2 } from '../../../../store/actions/homeActionCreator';
import {
    getTripDetailsV3,
    emptySingleTripData
} from "../../../../store/actions/tripActionCreator";
import * as logger from "../../../../logger";
import { TripsTabSupplierCss } from "../SupplierCss";
import { getTripStartDateFilterValues, numberFormat, getDatePickerDateInStringDDMMMYYYY } from "../../../../utils/utils";
import { Grid, IconButton, InputAdornment, Button } from "@material-ui/core";
import SearchIcon from '@material-ui/icons/Search';
import ArrowRightIcon from '@material-ui/icons/ArrowRight';
import FiberManualRecordIcon from "@material-ui/icons/FiberManualRecord";
import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf';
import DateFilter from '../../../components/FilterComponent/DateFilter';
import CustomDateFilterDialog from '../../../components/FilterComponent/CustomDateFilter';
import TripStatusFilter from '../../../components/FilterComponent/TripStatusFIlter';
import ReportsDialog from '../../../components/ReportsDialog/ReportsDialog';
import TripTimelineAction from '../../../components/Trip/TripTimelineActionDialog';
import ActionButton from '../../../components/Actions/ActionButton';
import ColumnActions from '../../../components/Actions/ColumnActions';
import TripActionDialog from '../../../components/Trip/TripActionDialog';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import InfoDialog from "../../../components/Dialog/InfoDialog";
import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight';
import { PaperPlaneIconWhite } from '../../../../components/icons';
import SingleSupplierTopCard from '../../../components/TopCard/SingleSupplierTopCard';
import { Waypoint } from "react-waypoint";
import { debounce } from 'lodash';
import { defaultPageNo, defaultPageSize, defaultDebounceMs } from '../../../../paginationVariables';
import moment from 'moment';

const TripsTabSupplier = ({ user, dispatchGetSingleVendorLedger, dispatchTripDetailsAction, disPatchEmptySingleTripData, trip }) => {

    const [selectedFilterStatus, setSelectedFilterStatus] = useState("ACTIVE");
    const [selectedFilterDate, setSelectedFilterDate] = useState("ALL_MONTHS");
    const [changeFlag, setChangeFlag] = useState(false);
    const [actionClickDialog, setActionClickDialog] = useState(false);
    const [tripDetails, setTripDetails] = useState({});
    const [singleVendorLedgerData, setSingleVendorLedgerData] = useState([]);
    const [addTripActionOpen, setAddTripActionOpen] = useState(false);
    const [addPaymentAction, setAddPaymentAction] = useState({
        action: 'add_payment',
        label: 'Settle Supplier Balance',
        tabsFormat: false,
        confirmText: 'Settle Supplier Balance',
        person: 'supplier'
    });
    const [searchText, setSearchText] = useState("");
    const [customFilter, setCustomFilter] = useState(false);
    const [customFilterValue, setCustomFilterValue] = useState({});
    const [infoOpen, setInfoOpen] = React.useState(false);
    const [currentPageNo, setCurrentPageNo] = useState(defaultPageNo);
    const [currentPageSize, setCurrentPageSize] = useState(defaultPageSize);
    const [loadingText, setLoadingText] = useState("No Trips are available");

    const classes = TripsTabSupplierCss();

    let location = useLocation();
    let history = useHistory();
    let path = location && location.pathname ? location.pathname.split("/") : [];
    let vendorIdValue = path && path[path.length - 1] ? path[path.length - 1] : "";
    const getDateRangeValue = () => {
        let date = `${moment(dateFilterValues[selectedFilterDate]["startDateRange"]["startTimeEpoch"] * 1000).format('YYYY-MM-DD')},${moment(dateFilterValues[selectedFilterDate]["startDateRange"]["endTimeEpoch"] * 1000).format('YYYY-MM-DD')}`;
        if (customFilterValue && customFilterValue.startTimeEpoch) {
            date = `${moment(customFilterValue["startTimeEpoch"] * 1000).format('YYYY-MM-DD')},${moment(customFilterValue["endTimeEpoch"] * 1000).format('YYYY-MM-DD')}`;
        }
        return [date]
    }
    const goToTripView = (data) => {
        if (data && data.journeyId) {
            history.push({
                pathname: `/trips/view/${data.journeyId}`,
                state: {
                    id: 7,
                    tripData: data,
                    tripView: true,
                    pageTitle: 'Trip Details',
                    pageSubTitle: data && data.vehicleNumber ? data.vehicleNumber : ''
                }
            });
        }
    }
    let dateFilterValues = getTripStartDateFilterValues();
    const [tripTimelineActionOpen, setTripTimelineActionOpen] = useState(false);

    const onSearchBlur = debounce(query => {
        setSingleVendorLedgerData([]);
        setLoadingText("Loading........");
        setCurrentPageNo(defaultPageNo)
        fecthSupplierTrips(false, query)
    }, user && user.configs && user.configs.dwebSearchBebounceMs ? parseInt(user.configs.dwebSearchBebounceMs) : defaultDebounceMs);

    const getPaginatedData = () => {
        fecthSupplierTrips(true)
    }

    const fecthSupplierTrips = (pagination, search) => {
        let vendorLedgerRequestData = {
            fleetOwnerId: user.userInfo.entityId,
            vendorId: vendorIdValue,
            status: TRIP_FILTER_STATUS_MAPPING[selectedFilterStatus],
            startDateRange: dateFilterValues[selectedFilterDate]["startDateRange"],
            pageNo: defaultPageNo,
            pageSize: defaultPageSize,
            search: searchText,
            filters: [
                {
                    "filterKey": "vendorId",
                    "values": [vendorIdValue]
                },
                {
                    "filterKey": "tripStatus",
                    "values": TRIP_FILTER_STATUS_MAPPING[selectedFilterStatus]
                },
                {
                    "filterKey": "startDate",
                    "values": getDateRangeValue()
                }
            ]
        }
        if (pagination) {
            vendorLedgerRequestData = {
                ...vendorLedgerRequestData,
                pageNo: currentPageNo + 1,
                pageSize: currentPageSize,
                searchText: searchText,
                merge: true
            }
        }
        if (search) {
            vendorLedgerRequestData.search = search && search == "null" ? "" : search;
        }
        dispatchGetSingleVendorLedger(vendorLedgerRequestData,
            () => {
                logger.log("Single Supplier Trips tab Dweb", "Single Supplier Fetch Successfull");
                setLoadingText("No Trips are available");
            },
            () => {
                logger.log("Single Supplier Trips tab Dweb", "Single Supplier Fetch Failed");
                setLoadingText("No Trips are available");
            }
        )
    }
    useEffect(() => {
        fecthSupplierTrips();
    }, []);
    const handleTripTimelineActionClose = (status) => {
        setTripTimelineActionOpen(status);
        if (vendorIdValue) {
            disPatchEmptySingleTripData();
            fecthSupplierTrips()
        }
    }
    const handleTripTimelineActionOpen = (status, tripId, data) => {
        if (status == 'PAYMENT_RECEIVED') {
            goToTripView(data)
        } else {
            if (tripId) {
                dispatchTripDetailsAction(tripId, () => {
                    if (user.singleTripData) {
                        setTripTimelineActionOpen(true);
                    }
                });
            }
        }
    }
    const handleSettleVendorBalance = (data) => {
        let act = { ...addPaymentAction }
        act.defaultAmount = Number(data.amount);
        setAddPaymentAction(act);
        if (data.tripId) {
            dispatchTripDetailsAction(data.tripId, () => {
                if (user.singleTripData) {
                    setAddTripActionOpen(true);
                }
            });
        }
    }
    const handleaddTripActionClose = (status) => {
        setAddTripActionOpen(status);
        if (vendorIdValue) {
            disPatchEmptySingleTripData();
            fecthSupplierTrips()
        }
    }

    useEffect(() => {
        if (changeFlag) {
            setLoadingText("Loading........");
            setSingleVendorLedgerData([]);
            setCurrentPageNo(defaultPageNo)
            let vendorLedgerRequestData = {
                fleetOwnerId: user.userInfo.entityId,
                vendorId: vendorIdValue,
                status: TRIP_FILTER_STATUS_MAPPING[selectedFilterStatus],
                startDateRange: dateFilterValues[selectedFilterDate]["startDateRange"],
                pageNo: defaultPageNo,
                pageSize: defaultPageSize,
                search: searchText,
                filters: [
                    {
                        "filterKey": "vendorId",
                        "values": [vendorIdValue]
                    },
                    {
                        "filterKey": "tripStatus",
                        "values": TRIP_FILTER_STATUS_MAPPING[selectedFilterStatus]
                    },
                    {
                        "filterKey": "startDate",
                        "values": getDateRangeValue()
                    }
                ]
            }

            if (customFilterValue && customFilterValue.startTimeEpoch) {
                vendorLedgerRequestData.startDateRange = customFilterValue
            }

            dispatchGetSingleVendorLedger(vendorLedgerRequestData,
                (data) => {
                    if (data && data.status && data.status.code == 200) {
                        logger.log("Single Supplier Trips tab Dweb", "Single Supplier Fetch Successfull");
                        setLoadingText("No Trips are available");
                    }
                },
                () => {
                    logger.log("Single Supplier Trips tab Dweb", "Single Supplier Fetch Failed");
                    setLoadingText("No Trips are available");
                }
            )
        }
    }, [selectedFilterStatus, selectedFilterDate, customFilterValue]);

    useEffect(() => {
        setSingleVendorLedgerData(user.singleVendorLedgerData)
    }, [user.singleVendorLedgerData]);

    const muiColumns = [
        {
            name: "startDate",
            label: "Date",
            options: {
                filter: true,
                sort: false,
                customBodyRender: (value, tableMeta, updateValue) => {
                    const rowIndex = tableMeta.rowIndex;

                    if (rowIndex === muiData.length - 3) {
                        return (
                            <Fragment>
                                <Waypoint
                                    onEnter={() => {
                                        if (user && user.singleVendorTripsMaxPage && user.singleVendorTripsMaxPage != currentPageNo) {
                                            getPaginatedData()
                                            setCurrentPageNo(currentPageNo + 1)
                                        }
                                    }}
                                />
                                <span className={classes.fwNormal}>{value}</span>
                            </Fragment>
                        );
                    } else {
                        return <span className={classes.fwNormal}>{value}</span>;
                    }
                }
            },
        },
        {
            name: "vehicleNumber",
            label: "Truck No",
            options: {
                filter: true,
                sort: false,
                customBodyRenderLite: (dataIndex, rowIndex) => {
                    return (
                        <>
                            <div style={{ display: 'flex' }}>
                                {muiData[dataIndex].vehicleNumArrayDweb && muiData[dataIndex].vehicleNumArrayDweb.map((item) => (
                                    <div className={classes.vehileNumber}>{item}</div>
                                ))
                                }
                            </div>
                        </>
                    )
                }
            },
        },
        {
            name: "startDest",
            label: "Route",
            options: {
                filter: true,
                sort: false,
                customBodyRenderLite: (dataIndex, rowIndex) => {
                    return (
                        <div className={classes.divV1}>
                            <div>{singleVendorLedgerData && singleVendorLedgerData[dataIndex] && singleVendorLedgerData[dataIndex].startLocation ? singleVendorLedgerData[dataIndex].startLocation : ""}</div>
                            <ArrowRightIcon className={classes.arrowRightV2} />
                            <div>{singleVendorLedgerData && singleVendorLedgerData[dataIndex] && singleVendorLedgerData[dataIndex].destinationLocation ? singleVendorLedgerData[dataIndex].destinationLocation : ""}</div>
                        </div>
                    )
                }
            },
        },
        {
            name: "vehicleHireCost",
            label: "Truck Hire Cost",
            options: {
                filter: true,
                sort: false,
                customBodyRender: (value, tableMeta, updateValue) => {
                    return (
                        <div className={classes.truckHireCost}>{value ? numberFormat(Number(value.replace(/,/g, ''))) : ""}</div>
                    )
                },
                customHeadRender: (columnMeta, updateDirection) => (
                    <th key={3} className={classes.thTruckRightAlign}>
                        {columnMeta.label}
                    </th>
                )
            },
        },
        {
            name: "status",
            label: "Trip Status",
            options: {
                filter: true,
                sort: false,
                customBodyRender: (value, tableMeta, updateValue) => {
                    return (
                        <div className={classes.statusDiv}> <FiberManualRecordIcon
                            className={classes[value + '_BULLET']}
                        ></FiberManualRecordIcon><div className={classes[value]}>{TRIP_STATUS_LABELS[value]}</div></div>
                    )
                }
            },
        },
        {
            name: "vendorBalance",
            label: "Supplier Balance",
            options: {
                filter: true,
                sort: false,
                customBodyRender: (value, tableMeta, updateValue) => {
                    return (
                        <div className={classes.supplierBalance}>{numberFormat(value)}</div>
                    )
                },
                customHeadRender: (columnMeta) => (
                    <th key={5} className={classes.thTruckRightAlign}>
                        {columnMeta.label}
                    </th>
                )
            },
        },
        {
            name: "id",
            label: "Actions",
            options: {
                filter: true,
                sort: false,
                customBodyRenderLite: (dataIndex, rowIndex) => {
                    let status = muiData && muiData[dataIndex] && muiData[dataIndex].status ? muiData[dataIndex].status : '';
                    let tripId = muiData && muiData[dataIndex] && muiData[dataIndex].id ? muiData[dataIndex].id : '';
                    let amount = muiData && muiData[dataIndex] && muiData[dataIndex].amount ? Number(muiData[dataIndex].amount) : '';

                    return (
                        <ColumnActions>
                            {amount > 0 ?
                                <ActionButton size="small" onClick={() => { handleSettleVendorBalance(muiData[dataIndex]) }} className={classes.iconButtonV1}>
                                    {TRIP_ACTIONS_SUPPLIER['POD_SUBMITTED']}
                                </ActionButton>
                                :
                                <ActionButton size="small" onClick={() => { handleTripTimelineActionOpen('PAYMENT_RECEIVED', tripId, muiData[dataIndex]) }} className={classes.iconButtonV2}>
                                    {TRIP_ACTIONS_SUPPLIER['PAYMENT_RECEIVED']}
                                </ActionButton>
                            }
                        </ColumnActions>
                    );

                },
                customHeadRender: (columnMeta) => (
                    <th key={6} className={classes.thTruckCenterAlign}>
                        {columnMeta.label}
                    </th>
                )
            },
        },

    ];
    const muiData = singleVendorLedgerData ? singleVendorLedgerData : [];
    const options = {
        rowsPerPage: 100,
        pagination: false,
        rowsPerPageOptions: [10, 100, 250],
        filterType: "multiselect",
        fixedHeader: true,
        tableBodyHeight: tableHeightWithSparklineSingle,
        selectableRows: 'none',
        searchOpen: true,
        search: false,
        sort: false,
        jumpToPage: false,
        download: false,
        filter: false,
        print: false,
        viewColumns: false,
        onCellClick: (colData, cellMeta, rowIndex) => {
            if (cellMeta && cellMeta.colIndex != 6) {
                goToTripView(muiData[cellMeta.dataIndex]);
            }
        },
        customToolbar: (data) => {
            return <>
                <div className={classes.divV3}>
                    <div className={classes.mtV2}>
                        <span>
                            <div className={classes.divDate}>Date</div>
                            <DateFilter fromSingleSupplierTripsTab={true} dateValue={handleDateValue} />
                        </span>
                        <span className={classes.mlV2}>
                            <div className={classes.divTripStatus}>Trip Status</div>
                            <TripStatusFilter fromSingleSupplierTripsTab={true} status={handleTripStatusValue} defaultTripStatusFilter={selectedFilterStatus} />
                        </span>
                    </div>

                </div>
            </>
        },
        customToolbarSelect: (selectedRows, displayData, setSelectedRows) => {

        },
        searchProps: {
            variant: "outlined",
            //value: searchText,
            InputProps: {
                startAdornment: <InputAdornment position="start"><SearchIcon /></InputAdornment>,
            },
            onBlur: (e) => {
            },
            onKeyUp: (e) => {
            },
            onKeyDown: (event) => {
                if (event.keyCode === 27) {
                }
            }
        },
        searchPlaceholder: 'Search ',
        onSearchChange: (val) => {
            let value = val ? !val.replace(/\s/g, '').length ? val.trim() : val : "";
            setSearchText(value);
            if (value && value.length > 1) {
                onSearchBlur(value);
            } else if (searchText && value && value.trim().length <= 1) {
                setSearchText("");
                onSearchBlur("null")
            }else{
                setSearchText("");
                onSearchBlur("null")
            }
        },
        onSearchClose: () => {
        },
        customSearch: (searchQuery, currentRow, columns) => {
            let isFound = false;
            /*if (searchQuery && searchQuery.trim().length > 0) {
                searchQuery = searchQuery.trim()
                currentRow.forEach((col, index) => {
                    if (index == 0) {
                        col = getDatePickerDateInStringDDMMMYYYY(new Date(Number(col) * 1000));
                    }
                    if (col && col.toString().toLowerCase().indexOf(searchQuery.toLowerCase()) >= 0) {
                        isFound = true;
                    }
                });
            } else {
                isFound = true;
            }*/
            return true;
        },
        textLabels: {
            body: {
                // noMatch: <span className={classes.noMatch}>{loadingText}</span>,
                noMatch: loadingText,
                toolTip: "Sort",
                columnHeaderTooltip: column => `Sort for ${column.label}`
            }
        }
    };

    const handleDateValue = (value) => {
        if (value == "CUSTOM") {
            setCustomFilter(true);
        }
        else {
            setSelectedFilterDate(value);
            setCustomFilter(false);
            setCustomFilterValue({});
        }
        setChangeFlag(true);
    }

    const handleTripStatusValue = (value) => {
        setSelectedFilterStatus(value);
        setChangeFlag(true);
    }

    const handleActionClick = (index) => {
        let value = singleVendorLedgerData[index];
        setTripDetails(value);
        setActionClickDialog(true);
    }

    const handleActionClickClose = () => {
        setActionClickDialog(false);
    }

    const handleCustomFilterClose = () => {
        setCustomFilter(false);
    }

    const handleCustomFilterConfirm = (value) => {
        setSelectedFilterDate("CUSTOM");
        setCustomFilter(false);
        setCustomFilterValue(value);
    }

    const handleInfoOpen = () => {
        setInfoOpen(true);
    }
    const handleInfoClose = () => {
        setInfoOpen(false);
    }

    return (
        <>
            <TapLayout>
                <SingleSupplierTopCard />
                <div style={{ marginTop: 16 }}>
                    <MUIDataTable title={""} data={muiData} columns={muiColumns} options={options} className="supplier-TTS-table" />
                </div>
            </TapLayout>
            {tripTimelineActionOpen && <TripTimelineAction trip={{}} open={tripTimelineActionOpen} onClose={handleTripTimelineActionClose} />}
            {addTripActionOpen && <TripActionDialog action={addPaymentAction} defaultPerson={addPaymentAction.person} confirmText={addPaymentAction.confirmText} defaultAmount={addPaymentAction.defaultAmount} open={addTripActionOpen} onClose={handleaddTripActionClose} />}
            {customFilter && <CustomDateFilterDialog open={customFilter} onClose={handleCustomFilterClose} onConfirm={handleCustomFilterConfirm} />}
            {infoOpen && <InfoDialog confirmOpen={infoOpen} confirmTitle={"Supplier Balance"} confirmMessage={"The total balance amount to be paid for all the trips with this supplier in this period"} onClose={handleInfoClose} />}

        </>
    );
}

const mapStateToProps = (state) => ({ user: state.user, trip: state.trip });
const mapDispatchToProps = (dispatch) => ({
    disPatchEmptySingleTripData: () => dispatch(emptySingleTripData()),
    dispatchTripDetailsAction: (tripId, onSuccess, onError) =>
        dispatch(getTripDetailsV3(tripId, onSuccess, onError)),
    dispatchGetSingleVendorLedger: (data, onSuccess, onFailure) => {
        dispatch(getSingleVendorLedgerDataV2(data, onSuccess, onFailure))
    }
});

const TripsTabSupplierWithRouter = withRouter(TripsTabSupplier);
export default connect(mapStateToProps, mapDispatchToProps)(TripsTabSupplierWithRouter);
